import "moment-timezone";
import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import Alert from "react-s-alert";
import AuthContext from "../auth-context";
import SalesPersonTasksService from "../utils/SalesPersonTasksService";

class AssignTaskModal extends Component {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    const authStore = this.context;
    this.isAdmin = authStore.hasRole("admin");
    
    this.state = {
      assignees: [],
      deals: [],
      loading: true,
      showAssigneeDetail: []
    };
  }

  componentDidMount() {
    if (this.props.show && this.props.task) {
      this.loadAssignees();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show && this.props.task) {
      this.loadAssignees();
    }
  }

  loadAssignees() {
    const { task } = this.props;
    if (!task) return;

    this.setState({ loading: true, showAssigneeDetail: [] });

    SalesPersonTasksService.getPossibleAssignees(task.id)
      .then(data => {
        const deals = data.deals.sort((a, b) => new Date(a.tcs_at) - new Date(b.tcs_at));
        const assignees = data.assignees
          .map((assignee) => {
            assignee.assignedToDeals = deals.filter(
              (d) => d.tcs_assigned_to === assignee.email
            );
            assignee.clashingBookings = deals.filter(
              (d) =>
                d.tcs_at === task.deal_tcs_at &&
                d.tcs_assigned_to === assignee.email &&
                d.id !== task.deal_id
            );
            if (!assignee.options.tcs_priority)
              assignee.options.tcs_priority = 10;
            return assignee;
          })
          .sort((a, b) =>
            a.options.tcs_priority > b.options.tcs_priority ? 1 : -1
          );

        const assigneeGroups = {
          workingNotBooked: assignees.filter(
            (a) => a.working && a.clashingBookings.length === 0
          ),
          notWorkingNotBooked: assignees.filter(
            (a) => !a.working && a.clashingBookings.length === 0
          ),
          workingBooked: assignees.filter(
            (a) => a.working && a.clashingBookings.length !== 0
          ),
          notWorkingBooked: assignees.filter(
            (a) => !a.working && a.clashingBookings.length !== 0
          ),
        };

        this.setState({ 
          assignees: assigneeGroups,
          deals: deals,
          loading: false 
        });
      })
      .catch(error => {
        console.error("Failed to load assignees:", error);
        Alert.error("Failed to load assignees");
        this.setState({ loading: false });
      });
  }

  assignTo(taskId, userId) {
    SalesPersonTasksService.update(taskId, { assignee_id: userId || null })
      .then((response) => {
        let assigneeName = "Unassigned";
        if (userId) {
          const user = this.props.users.find(u => u.id === userId);
          if (user) {
            assigneeName = user.name;
          }
        }
        Alert.success(`Assigned to ${assigneeName}`);
        this.props.onAssign(response.task);
      })
      .catch(error => {
        const errorMsg = error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors.join(", ")
          : "Failed to assign task";
        Alert.error(errorMsg);
      });
  }

  showDetails(as) {
    this.setState({
      showAssigneeDetail: this.state.showAssigneeDetail.includes(as.email) 
        ? this.state.showAssigneeDetail.filter((ad) => ad !== as.email) 
        : this.state.showAssigneeDetail.concat(as.email)
    });
  }

  render() {
    const { show, onClose, task } = this.props;
    const { assignees, loading, showAssigneeDetail } = this.state;

    if (!task) return null;

    const AssigneeTable = ({ title, assigneesToInclude }) => (
      <>
        <h5 style={{ fontWeight: 700 }}>{title}</h5>
        {assigneesToInclude.length === 0 ? (
          <p style={{ color: '#888', paddingLeft: 20 }}>no matches</p>
        ) : (
          <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table className="table table-condensed table-hover" style={{ minWidth: '600px' }}>
              <tbody>
                {assigneesToInclude.map((as) => {
                  return (
                    <React.Fragment key={as.email}>
                      <tr
                        style={{ cursor: "pointer", borderBottom: "1px solid #ccc" }}
                      >
                        <td onClick={() => this.showDetails(as)}>
                          <table>
                            <tbody>
                              <tr>
                                <td style={{ paddingLeft: 5, paddingRight: 5 }}>
                                  {as.options.tcs_priority}
                                </td>
                                <td style={{ paddingLeft: 5, paddingRight: 5 }}>
                                  {as.name} {as.region && `- ${as.region}`} &lt;{as.email}&gt;
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td onClick={() => this.showDetails(as)} style={{ width: 280 }}>
                          <div>
                            <div className="row">
                              <div className="col-md-6">
                                Assigned: {as.assignedToDeals.length}
                              </div>
                              <div className="col-md-6">
                                <span
                                  className={
                                    as.clashingBookings.length > 0
                                      ? "text-danger"
                                      : ""
                                  }
                                >
                                  Clashes: {as.clashingBookings.length}
                                </span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={{ width: 50 }}>
                          <Button
                            bsStyle="info"
                            bsSize="xs"
                            onClick={(e) => {
                              this.assignTo(task.id, as.id);
                              e.preventDefault();
                            }}
                          >
                            Assign
                          </Button>
                        </td>
                      </tr>
                      {showAssigneeDetail.includes(as.email) && as.options.tcs_work_hours && (
                        <tr>
                          <td colSpan={3} style={{ color: '#666', fontSize: 13, fontWeight: 600, padding: "0 30px", paddingBottom: (as.clashingBookings.length === 0 && as.assignedToDeals.length === 0 && '10px') }}>
                            {as.options.tcs_work_hours}
                          </td>
                        </tr>
                      )}

                      {showAssigneeDetail.includes(as.email) &&
                        (as.clashingBookings.length > 0 ||
                          as.assignedToDeals.length > 0) && (
                          <tr>
                            <td colSpan={3}>
                              <div style={{ padding: "0 10px 10px 10px", overflowX: 'auto' }}>
                                <table style={{ width: "100%", fontSize: 14, minWidth: '500px' }}>
                                  <tbody>
                                    {as.clashingBookings.map((deal) => (
                                      <tr key={deal.id} className="text-danger">
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          <Link
                                            to={`/m1/deals/${deal.id}`}
                                            target="_new"
                                          >
                                            Deal #{deal.id}
                                          </Link>
                                        </td>
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          Clash
                                        </td>
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          {deal.contact_name}
                                        </td>
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          Yr: {deal.student_year_level}
                                        </td>
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          Parents:{" "}
                                          {deal.tcs_parents_attending_tcs || "?"}/
                                          {deal.tcs_parents_in_household || "?"}
                                        </td>
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          {deal.tcs_at ? (
                                            <Moment format="h:mma MMM Do YYYY">
                                              {deal.tcs_at}
                                            </Moment>
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                    {as.assignedToDeals.map((deal) => (
                                      <tr key={deal.id}>
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          <Link
                                            to={`/m1/deals/${deal.id}`}
                                            target="_new"
                                          >
                                            Deal #{deal.id}
                                          </Link>
                                        </td>
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          Assigned
                                        </td>
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          {deal.contact_name}
                                        </td>
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          Yr: {deal.student_year_level}
                                        </td>
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          Parents:{" "}
                                          {deal.tcs_parents_attending_tcs || "?"}/
                                          {deal.tcs_parents_in_household || "?"}
                                        </td>
                                        <td style={{ padding: "0 0 5px 1px" }}>
                                          {deal.tcs_at ? (
                                            <Moment format="h:mma MMM Do YYYY">
                                              {deal.tcs_at}
                                            </Moment>
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </>
    );

    return (
      <Modal show={show} onHide={onClose} dialogClassName="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Assign Task{" "}
            <i className="fas fa-caret-right" style={{ margin: "0 10px" }}></i>{" "}
            {task.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <div
                style={{
                  marginBottom: 15,
                  paddingBottom: 5,
                  borderBottom: "1px solid #ccc",
                  fontSize: 18,
                }}
              >
                <div className="pull-right">
                  <Button
                    bsStyle="info"
                    bsSize="xs"
                    onClick={(e) => {
                      this.assignTo(task.id, null);
                      e.preventDefault();
                    }}
                  >
                    Set to UNASSIGNED
                  </Button>
                </div>
                <div>
                  <strong>Task #{task.id}:</strong> {task.title}
                </div>
                {task.deal_id && (
                  <div style={{ fontSize: 14, color: "#666", marginTop: 5 }}>
                    {this.isAdmin ? (
                      <>
                        Related to <Link to={`/m1/deals/${task.deal_id}`} target="_blank">Deal #{task.deal_id}</Link>
                        {task.deal_contact_name && <span> - {task.deal_contact_name}</span>}
                      </>
                    ) : (
                      <>
                        Related to Deal #{task.deal_id}
                        {task.deal_contact_name && <span> - {task.deal_contact_name}</span>}
                      </>
                    )}
                  </div>
                )}
                {task.deal_tcs_at && (
                  <div style={{ fontSize: 14, color: "#666" }}>
                    <Moment format="h:mma MMM Do YYYY">{task.deal_tcs_at}</Moment>
                  </div>
                )}
                {task.assignee_name && (
                  <div style={{ fontSize: 14, color: "#666", marginTop: 5 }}>
                    Currently assigned to: {task.assignee_name}
                  </div>
                )}
              </div>
              {assignees && (
                <>
                  <AssigneeTable
                    title="Working, Not Booked"
                    assigneesToInclude={assignees.workingNotBooked}
                  />
                  <AssigneeTable
                    title="Not Working, Not Booked"
                    assigneesToInclude={assignees.notWorkingNotBooked}
                  />
                  <AssigneeTable
                    title="Working, Booked"
                    assigneesToInclude={assignees.workingBooked}
                  />
                  <AssigneeTable
                    title="Not Working, Booked"
                    assigneesToInclude={assignees.notWorkingBooked}
                  />
                </>
              )}

              <ul style={{ marginTop: 20, fontSize: 14 }}>
                <li>Assigned figures are in the next 7 days</li>
                <li>
                  Clashes only checks for other TCS's at the same time, not coach
                  availability
                </li>
                <li>
                  Changing the assignee here will also update the deal's TCS assignee
                </li>
              </ul>
            </>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

export default AssignTaskModal;
